/* @ngInject */
export default class PausedAlertsFilterController {
    constructor($scope, currentFilter, onUpdate, onClose) {
        this.$scope = $scope;
        this.selectedValue = currentFilter || 'paused'; // Default to 'paused' if no filter is set
        this.onUpdate = onUpdate;
        this.onClose = onClose;
    }

    $onInit() {
        // Controller initialized with selectedValue from parent
    }

    clear() {
        this.selectedValue = null;
        this.apply();
    }

    apply() {
        this.onUpdate(this.selectedValue);
        this.onClose();
    }
}

